import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'motion/react'

interface ParallaxProps {
    children: ReactNode
    offset?: number
    className?: string
}

// Drifts its content against the scroll direction for a sense of depth.
const Parallax: FC<ParallaxProps> = ({ children, offset = 60, className }): ReactNode => {
    const ref = useRef<HTMLDivElement>(null)
    const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] })
    const y = useTransform(scrollYProgress, [0, 1], [offset, -offset])

    return (
        <motion.div ref={ref} style={{ y }} className={className}>
            {children}
        </motion.div>
    )
}

export default Parallax
